<template>
  <v-list-item>
    <v-list-item-content class="d-flex">
      <div>
        {{ contentTitle }}: <span class="current-value">{{ currentValue }}</span
        >,
        <span class="previous-value">{{ previousValue }}</span>
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<style scoped>
.current-value {
  color: black;
  background-color: #8fd14f;
}

.previous-value {
  color: black;
  text-decoration: line-through;
  text-decoration-color: #686868;
  background-color: #e6e6e6;
}
</style>

<script>
export default {
  props: {
    contentTitle: {
      type: String,
      required: true,
    },
    currentValue: {
      type: String,
      required: true,
    },
    previousValue: {
      type: String,
      required: true,
    },
  },
}
</script>
